import { ItemInformationErrorReportRepository } from '../repositories/item_information_error_report_repository';

export class ItemInformationErrorReportAction {

  static init() {
    // 「指摘箇所」セレクトボックス変更時処理
    this.changePointingOutSelectAction();
    // 「コメント」テキストエリア 残り文字数カウント処理
    this.countDownInputComment();
    // 「送信」ボタンクリック処理
    this.send();
  }

  // 「指摘箇所」セレクトボックスの値により、「項目」セレクトボックスの活性状態・内容を変更する
  static changePointingOutSelectAction() {

    document.querySelector("#reportedpointingout")?.addEventListener(
      "change",
      (event: Event) => {

        const options = (event!.target as HTMLSelectElement).options;

        const reportedItemSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector("#reporteditem");

        reportedItemSelect!.innerHTML = ""

        for(let index = 0; options!.length > index; index++) {

         if(options[index]!.selected && index === 0){
            // セレクトボックス項目の初期化
            this.resetSelectBox();
            return;
          } else if(options[index]!.selected) {

            reportedItemSelect!.disabled = false;

            // 「項目」セレクトボックス設定値を取得
            const itemSelectJson =  JSON.parse(options[index]!.dataset.itemSelect as string);

            itemSelectJson!.forEach((item) => {
              reportedItemSelect!.innerHTML += `
                <option value=${item["value"]}>${item["text"]}</option>
                `;
            });
          }
        }
      },
      false
    );
  }

  // コメント欄 残り文字数カウントダウン
  static countDownInputComment() {

        document.querySelector("#comment")?.addEventListener(
          "input",
          (event: Event) => {

            // 「コメント」テキストエリア
            const commentTextArea: HTMLTextAreaElement = <HTMLTextAreaElement>event!.target;

            const maxLength: number = commentTextArea!.maxLength;
            const inputLength: number = commentTextArea!.value!.length;
            const result: number = (maxLength - inputLength) > 0 ? (maxLength - inputLength) : 0;

            document.querySelector<HTMLParagraphElement>('#comment-countdown')!.innerHTML = `残り${result}文字`;
          },
          false
        );
  }

  // 送信ボタンクリック処理
  static send() {

  　　document.querySelector("#send-errorReport")?.addEventListener(
       'click',
       () => {

         const pointingOutSelectOptions: HTMLOptionsCollection
           = <HTMLOptionsCollection>(document.querySelector("#reportedpointingout") as HTMLSelectElement)!.options;

         let pointingOut: string = "";

         for(let index = 0; pointingOutSelectOptions!.length > index; index++) {
           if(pointingOutSelectOptions[index].selected) {
             pointingOut = pointingOutSelectOptions[index].dataset.selectValue as string;
             break;
           }
         }

         const reportedItem: string = (document.querySelector("#reporteditem") as HTMLSelectElement)!.value as string;

         const comment: string = (document!.querySelector("#comment") as HTMLTextAreaElement)!.value as string;

         // 送信元画面
         const sendDisplay: string = (document.querySelector("#sendDisplay") as HTMLInputElement)!.value as string;

         if (sendDisplay === "ITEM_DETAIL") {
           // 送信元が商品詳細の場合

           const supplierId: string = (document.querySelector("#supplierId") as HTMLInputElement)!.value as string;

           const catalogItemCode: string = (document.querySelector("#catalogItemCode") as HTMLInputElement)!.value as string;

           ItemInformationErrorReportRepository.callCreateItemImprovementMessage(
             comment,
             pointingOut,
             reportedItem,
             supplierId,
             catalogItemCode,
             "",
             "1"
           );

         } else {
           // 送信元がバリエーション一覧の場合
           const itemGroupCode: string = (document.querySelector("#itemGroupCode") as HTMLInputElement)!.value as string;

           ItemInformationErrorReportRepository.callCreateItemImprovementMessage(
             comment,
             pointingOut,
             reportedItem,
             "",
             "",
             itemGroupCode,
             "2"
           );

         }
         // 画面入力項目の初期化
         this.resetSelectBox();
         this.resetComment();
       },
       false
     );
  }

  // セレクトボックス項目の初期化
  static resetSelectBox() {

    // 「指摘箇所」セレクトボックス
    const pointingOutSelectOptions: HTMLSelectElement= <HTMLSelectElement>document.querySelector("#reportedpointingout");
    pointingOutSelectOptions!.value = "";

    // 「項目」セレクトボックス
    const reportedItemSelect: HTMLSelectElement = <HTMLSelectElement>document.querySelector("#reporteditem");
    reportedItemSelect!.disabled = true;

    reportedItemSelect!.innerHTML = `
      <option value="">項目を選択してください</option>
     `;
  }

  // コメント・残り文字数の初期化
  static resetComment() {

    // コメント
    const commentTextArea: HTMLTextAreaElement = <HTMLTextAreaElement>document.querySelector("#comment");
    commentTextArea.value = "";

    // 残り文字数
    document.querySelector<HTMLParagraphElement>('#comment-countdown')!.innerHTML = `残り${commentTextArea!.maxLength}文字`;
  }

}
